'use client';

import { useEffect, useState } from 'react';
import AppImage from '@/components/ui/AppImage';

export default function HeroSlideshow() {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const slides = [
  {
    id: 'slide_drinkware',
    src: "https://media.istockphoto.com/id/1618713841/photo/modern-metal-water-bottles-with-olive-tree-bushes-water-surface-on-the-background.webp?a=1&b=1&s=612x612&w=0&k=20&c=kdNFTQLzMvTgaN2xPueKztS5CHpYmrk_A957xABQbec=",
    alt: 'Collection of premium stainless steel water bottles and insulated mugs with corporate branding on wooden table',
    category: 'Drinkware'
  },
  {
    id: 'slide_foodware',
    src: "https://plus.unsplash.com/premium_photo-1736505438059-49c20fc32ff7",
    alt: 'Elegant bamboo products',
    category: 'Foodware'
  },
  {
    id: 'slide_pouches',
    src: "https://images.unsplash.com/photo-1732726345661-836c96f4d5f6",
    alt: 'Canvas and leather pouches with custom embroidered logos',
    category: 'Pouches'
  },
  {
    id: 'slide_calendars',
    src: "https://images.unsplash.com/photo-1525280784898-86fc8963da25",
    alt: 'Minimalist desk calendar with custom corporate design on modern office desk',
    category: 'Calendars'
  }];


  return (
    <div data-component-id="src\app\homepage\components\HeroSlideshow.tsx:41:4" data-component-path="src\app\homepage\components\HeroSlideshow.tsx" data-component-line="41" data-component-end-line="80" data-component-file="HeroSlideshow.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20w-full%20h-%5B320px%5D%20sm%3Ah-%5B420px%5D%20md%3Ah-%5B600px%5D%20overflow-hidden%20group%20border%20border-border%22%7D" className="relative w-full h-[320px] sm:h-[420px] md:h-[600px] overflow-hidden group border border-border">
      {isHydrated &&
      <div data-component-id="src\app\homepage\components\HeroSlideshow.tsx:43:6" data-component-path="src\app\homepage\components\HeroSlideshow.tsx" data-component-line="43" data-component-end-line="57" data-component-file="HeroSlideshow.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20w-full%20h-full%22%7D" className="absolute inset-0 w-full h-full">
          {slides?.map((slide, index) =>
        <div data-component-id="src\app\homepage\components\HeroSlideshow.tsx:45:8" data-component-path="src\app\homepage\components\HeroSlideshow.tsx" data-component-line="45" data-component-end-line="55" data-component-file="HeroSlideshow.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22hero-slide%20absolute%20inset-0%20w-full%20h-full%22%7D"
          key={slide?.id}
          className={`hero-slide absolute inset-0 w-full h-full`}
          style={{ animationDelay: `${index * 6}s` }}>

              <AppImage data-component-id="src\app\homepage\components\HeroSlideshow.tsx:50:14" data-component-path="src\app\homepage\components\HeroSlideshow.tsx" data-component-line="50" data-component-end-line="53" data-component-file="HeroSlideshow.tsx" data-component-name="AppImage" data-component-content="%7B%22elementName%22%3A%22AppImage%22%2C%22className%22%3A%22w-full%20h-full%20object-cover%20img-editorial%20hover-scale%22%7D"
            src={slide?.src}
            alt={slide?.alt}
            className="w-full h-full object-cover img-editorial hover-scale" />

            </div>
        )}
        </div>
      }
      <div data-component-id="src\app\homepage\components\HeroSlideshow.tsx:59:6" data-component-path="src\app\homepage\components\HeroSlideshow.tsx" data-component-line="59" data-component-end-line="79" data-component-file="HeroSlideshow.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20bottom-0%20right-0%20p-4%20sm%3Ap-6%20md%3Ap-8%20flex%20gap-4%20items-end%20w-full%20sm%3Aw-auto%20justify-center%20sm%3Ajustify-end%22%7D" className="absolute bottom-0 right-0 p-4 sm:p-6 md:p-8 flex gap-4 items-end w-full sm:w-auto justify-center sm:justify-end">
        <a data-component-id="src\app\homepage\components\HeroSlideshow.tsx:60:8" data-component-path="src\app\homepage\components\HeroSlideshow.tsx" data-component-line="60" data-component-end-line="78" data-component-file="HeroSlideshow.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22%2Fproducts%22%2C%22className%22%3A%22bg-primary%20text-primary-foreground%20px-6%20sm%3Apx-8%20py-3%20flex%20items-center%20gap-3%20text-sm%20font-medium%20hover%3Abg-accent%20transition-colors%20uppercase%20tracking-widest%20font-sans%20w-full%20sm%3Aw-auto%20justify-center%22%2C%22textContent%22%3A%22Explore%20Products%22%7D"
          href="/products"
          className="bg-primary text-primary-foreground px-6 sm:px-8 py-3 flex items-center gap-3 text-sm font-medium hover:bg-accent transition-colors uppercase tracking-widest font-sans w-full sm:w-auto justify-center">

          Explore Products
          <svg data-component-id="src\app\homepage\components\HeroSlideshow.tsx:65:10" data-component-path="src\app\homepage\components\HeroSlideshow.tsx" data-component-line="65" data-component-end-line="77" data-component-file="HeroSlideshow.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round">

            <path data-component-id="src\app\homepage\components\HeroSlideshow.tsx:76:12" data-component-path="src\app\homepage\components\HeroSlideshow.tsx" data-component-line="76" data-component-end-line="76" data-component-file="HeroSlideshow.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M7 7h10v10M7 17L17 7" />
          </svg>
        </a>
      </div>
    </div>);

}